// extracted by mini-css-extract-plugin
export var filter = "filter-select-module--filter--52895";
export var typoBody1 = "filter-select-module--typo--body-1--b0a54";
export var typoBody2 = "filter-select-module--typo--body-2--69b07";
export var typoBold = "filter-select-module--typo--bold--1f6e0";
export var typoButton = "filter-select-module--typo--button--e32ef";
export var typoCaption = "filter-select-module--typo--caption--a56b8";
export var typoH1 = "filter-select-module--typo--h1--9d1ee";
export var typoH2 = "filter-select-module--typo--h2--9b91e";
export var typoH3 = "filter-select-module--typo--h3--ca000";
export var typoHero = "filter-select-module--typo--hero--80c6e";